import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import WorkspaceFormInput from 'workspace/WorkspaceFormInput'
import { changeFormData } from 'workspace/actions'
import DatePicker from 'components/DatePicker'

const WorkspaceFormEngineeringFinishedAt = ({ engineeringFinishedAt, onChange }) => (
  <WorkspaceFormInput attribute='engineeringFinishedAt'>
    <DatePicker
      className='workspace-form__input'
      selected={engineeringFinishedAt}
      onChange={value => onChange({ engineeringFinishedAt: value })}
      showTimeSelect
      timeIntervals={1}
      precision='minute'
    />
  </WorkspaceFormInput>
)

WorkspaceFormEngineeringFinishedAt.propTypes = {
  engineeringFinishedAt: PropTypes.object,
  onChange: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  engineeringFinishedAt: state.form.data.engineeringFinishedAt
})

const mapDispatchToProps = ({
  onChange: changeFormData
})

export default connect(mapStateToProps, mapDispatchToProps)(WorkspaceFormEngineeringFinishedAt)
